export const surgeriesBySpecialisation = {
    "General Physician": [],
    "Cardiologist": [
      "Angioplasty",
      "Pacemaker Insertion",
      "Cardiac Catheterization",
      "Implantable Cardioverter Defibrillator (ICD)",
      "Atherectomy"
    ],
    "Gynecologist": [
      "Cesarean Section (C-Section)",
      "Hysterectomy",
      "Dilation and Curettage (D&C)",
      "Myomectomy",
      "Tubal Ligation",
      "Ovarian Cyst Removal",
      "Endometrial Ablation"
    ],
    "Orthopedic": [
      "Knee Replacement",
      "Hip Replacement",
      "Fracture Repair",
      "Arthroscopy",
      "Spinal Fusion",
      "ACL Reconstruction",
      "Rotator Cuff Repair"
    ],
    "ENT": [
      "Tonsillectomy",
      "Septoplasty",
      "Sinus Surgery (FESS)",
      "Cochlear Implant",
      "Tympanoplasty",
      "Thyroidectomy",
      "Adenoidectomy"
    ],
    "Neurologist": [],
    "Pediatrician": [],
    "General Surgery": [
      "Appendectomy",
      "Hernia Repair",
      "Cholecystectomy (Gallbladder Removal)",
      "Hemorrhoidectomy",
      "Colon Resection",
      "Mastectomy",
      "Thyroidectomy"
    ],
    "Dentist": [
      "Tooth Extraction",
      "Root Canal Treatment",
      "Dental Implants",
      "Crown and Bridge Placement",
      "Orthognathic Surgery"
    ],
    "Urology": [
      "Kidney Stone Removal",
      "TURP (Prostate Surgery)",
      "Nephrectomy",
      "Ureteroscopy",
      "Vasectomy",
      "Cystoscopy"
    ],
    "Ophthalmology": [
      "Cataract Surgery",
      "LASIK",
      "Glaucoma Surgery",
      "Retinal Detachment Repair",
      "Corneal Transplant"
    ],
    "Oncology": [
      "Tumor Resection",
      "Mastectomy",
      "Lymph Node Dissection",
      "Whipple Procedure",
      "Radiofrequency Ablation"
    ],
    "Nephrology": [
      "Kidney Biopsy",
      "Dialysis Catheter Insertion",
      "AV Fistula Surgery"
    ],
    "Gastroenterology": [
      "Endoscopy",
      "Colonoscopy with Polypectomy",
      "ERCP",
      "Esophageal Dilation",
      "PEG Tube Placement"
    ],
    "Pulmonology": [
      "Bronchoscopy",
      "Thoracentesis",
      "Pleurodesis",
      "Lung Biopsy"
    ],
    "Endocrinology": [],
    "Radiology": [
      "CT-Guided Biopsy",
      "Angiography",
      "Radiofrequency Ablation",
      "Vertebroplasty"
    ],
    "Anesthesiology": [
      "Spinal Anesthesia",
      "Epidural Injections",
      "Nerve Block Procedures",
      "Pain Management Injections"
    ],
    "Emergency Medicine": [
      "Wound Suturing",
      "Chest Tube Insertion",
      "Emergency Laparotomy",
      "Airway Management (Intubation)"
    ],
    "Obstetrics": [
      "Normal Vaginal Delivery",
      "Cesarean Section (C-Section)",
      "Episiotomy",
      "Manual Removal of Placenta"
    ],
    "Dermatology": [],
    "Psychiatry": [],
    "Rheumatology": [],
    "Pathology": [],
    "Critical Care": [],
    "Infectious Disease": [],
    "Geriatrics": [],
    "Sports Medicine": [],
    "Plastic Surgery": [],
    "Vascular Surgery": [],
    "Neurosurgery": [],
    "Thoracic Surgery": [],
    "Pain Management": [],
    "Palliative Care": [],
    "Family Medicine": [],
    "Internal Medicine": [],
    "Ayurveda": [],
    "Homeopathy": [],
    "Physiotherapy": []
  };

/** All specialisation options for dropdowns (e.g. Add/Edit User). Use with SPECIALISATION_OPTIONS. */
export const SPECIALISATION_OPTIONS = Object.keys(surgeriesBySpecialisation) as string[];

/** Value used in dropdown to show "Custom specialisation" text input. */
export const CUSTOM_SPECIALISATION_VALUE = '__CUSTOM__';
